import React from 'react';

const ActionBar = ({disabled, isPreparingPayslip, isPayslipSent,
    onOpenDialog, onResetForm}) => (

    <div className='row'>
        <div className='col-sm-12 col-md-6 col-xl-4'>
            <button className='pcb-button primary' disabled={disabled} onClick={onOpenDialog} id="open-modal">
                {isPreparingPayslip ?
                    'PREPARING PAYSLIP' : 'GET A PAYSLIP'
                }
            </button>
        </div>

        <div className='col-sm-12 col-md-6 col-xl-4 offset-xl-4'>
            <button className='pcb-button' onClick={onResetForm}>
                CLEAR FORMS
            </button>
        </div>
    </div>
);

export default ActionBar;



// WEBPACK FOOTER //
// ./src/components/Calculator/ActionBar.js